import { c as _c } from "react/compiler-runtime";
import { Heading, LinkPanel } from "@navikt/ds-react";
import NextLink from "next/link";
import { AktivitetskravBox } from "@/components/box/AktivitetskravBox";
import type { AktivitetskravViewItem } from "@/components/view/viewUtils";
import { useFerdigstillForhandsVarsel } from "@/data/ferdigstillVarsel";
import { getShortDateFormat } from "@/utils/dateUtils";
const getHeaderText = (viewItem: AktivitetskravViewItem) => {
  switch (viewItem.type) {
    case "UNDER_BEHANDLING":
      return "NAV vurderer aktivitetsplikten din";
    case "INNSTILLING_OM_STANS":
    case "IKKE_OPPFYLT":
      return "Svarfristen har gått ut";
    case "FORHANDSVARSEL":
      return "Forhåndsvarsel om stans av sykepenger";
    case "MOTTATT_VURDERING":
      return "Du har mottatt en vurdering av din aktivitetsplikt";
  }
};
interface Props {
  historicVurderinger: AktivitetskravViewItem[] | null;
}
export const HistoricEventsSummary = t0 => {
  const $ = _c(10);
  const {
    historicVurderinger
  } = t0;
  if (historicVurderinger && historicVurderinger.length > 0) {
    let t1;
    if ($[0] !== historicVurderinger) {
      t1 = historicVurderinger?.some(_temp) && <FerdigstillForhandsVarsel />;
      $[0] = historicVurderinger;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Heading size="medium" level="2" spacing={true}>Tidligere hendelser vedrørende din aktivitetsplikt</Heading>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== historicVurderinger) {
      t3 = historicVurderinger.map(_temp2);
      $[3] = historicVurderinger;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t3) {
      t4 = <AktivitetskravBox>{t2}{t3}</AktivitetskravBox>;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== t1 || $[8] !== t4) {
      t5 = <>{t1}{t4}</>;
      $[7] = t1;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  return null;
};
const FerdigstillForhandsVarsel = () => {
  useFerdigstillForhandsVarsel();
  return null;
};
function _temp(item) {
  return item.type === "FORHANDSVARSEL";
}
function _temp2(item_0) {
  return <LinkPanel href={`/${item_0.vurdering.internUuid}`} border={true} as={NextLink} key={item_0.vurdering.internUuid}><LinkPanel.Title>{item_0.vurdering.sistVurdert ? getShortDateFormat(item_0.vurdering.sistVurdert) : getShortDateFormat(item_0.vurdering.createdAt)}: {getHeaderText(item_0)}</LinkPanel.Title></LinkPanel>;
}